import { ServiceType, stackIntercept } from "@protobuf-ts/runtime-rpc";
import { MessageType, UnknownFieldHandler, WireType, reflectionMergePartial } from "@protobuf-ts/runtime";
// src/spell/service.ts
/**
* @generated from protobuf enum elephant.spell.CorrectionLevel
*/
let CorrectionLevel = /* @__PURE__ */ function(CorrectionLevel) {
	/**
	* @generated from protobuf enum value: LEVEL_UNSPECIFIED = 0;
	*/
	CorrectionLevel[CorrectionLevel["LEVEL_UNSPECIFIED"] = 0] = "LEVEL_UNSPECIFIED";
	/**
	* @generated from protobuf enum value: LEVEL_ERROR = 1;
	*/
	CorrectionLevel[CorrectionLevel["LEVEL_ERROR"] = 1] = "LEVEL_ERROR";
	/**
	* @generated from protobuf enum value: LEVEL_SUGGESTION = 2;
	*/
	CorrectionLevel[CorrectionLevel["LEVEL_SUGGESTION"] = 2] = "LEVEL_SUGGESTION";
	return CorrectionLevel;
}({});
var SupportedLanguagesRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.SupportedLanguagesRequest", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.SupportedLanguagesRequest
*/
const SupportedLanguagesRequest = new SupportedLanguagesRequest$Type();
var SupportedLanguagesResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.SupportedLanguagesResponse", [{
			no: 1,
			name: "languages",
			kind: "message",
			repeat: 2,
			T: () => Language
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.languages = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.languages.push(Language.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.languages.length; i++) Language.internalBinaryWrite(message.languages[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.SupportedLanguagesResponse
*/
const SupportedLanguagesResponse = new SupportedLanguagesResponse$Type();
var Language$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.Language", [{
			no: 1,
			name: "code",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.code = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.code = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.code !== "") writer.tag(1, WireType.LengthDelimited).string(message.code);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.Language
*/
const Language = new Language$Type();
var TextRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.TextRequest", [
			{
				no: 1,
				name: "text",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 2,
				name: "language",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "suggestions",
				kind: "scalar",
				T: 8
			},
			{
				no: 4,
				name: "custom_only",
				kind: "scalar",
				T: 8
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.text = [];
		message.language = "";
		message.suggestions = false;
		message.customOnly = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.text.push(reader.string());
					break;
				case 2:
					message.language = reader.string();
					break;
				case 3:
					message.suggestions = reader.bool();
					break;
				case 4:
					message.customOnly = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.text.length; i++) writer.tag(1, WireType.LengthDelimited).string(message.text[i]);
		if (message.language !== "") writer.tag(2, WireType.LengthDelimited).string(message.language);
		if (message.suggestions !== false) writer.tag(3, WireType.Varint).bool(message.suggestions);
		if (message.customOnly !== false) writer.tag(4, WireType.Varint).bool(message.customOnly);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.TextRequest
*/
const TextRequest = new TextRequest$Type();
var TextResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.TextResponse", [{
			no: 1,
			name: "misspelled",
			kind: "message",
			repeat: 2,
			T: () => Misspelled
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.misspelled = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.misspelled.push(Misspelled.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.misspelled.length; i++) Misspelled.internalBinaryWrite(message.misspelled[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.TextResponse
*/
const TextResponse = new TextResponse$Type();
var Misspelled$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.Misspelled", [{
			no: 1,
			name: "entries",
			kind: "message",
			repeat: 2,
			T: () => MisspelledEntry
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.entries = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.entries.push(MisspelledEntry.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.entries.length; i++) MisspelledEntry.internalBinaryWrite(message.entries[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.Misspelled
*/
const Misspelled = new Misspelled$Type();
var MisspelledEntry$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.MisspelledEntry", [
			{
				no: 1,
				name: "text",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "suggestions",
				kind: "message",
				repeat: 2,
				T: () => Suggestion
			},
			{
				no: 3,
				name: "level",
				kind: "enum",
				T: () => ["elephant.spell.CorrectionLevel", CorrectionLevel]
			},
			{
				no: 4,
				name: "status",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "spans",
				kind: "message",
				repeat: 2,
				T: () => TextSpan
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.text = "";
		message.suggestions = [];
		message.level = 0;
		message.status = "";
		message.spans = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.text = reader.string();
					break;
				case 2:
					message.suggestions.push(Suggestion.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 3:
					message.level = reader.int32();
					break;
				case 4:
					message.status = reader.string();
					break;
				case 5:
					message.spans.push(TextSpan.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.text !== "") writer.tag(1, WireType.LengthDelimited).string(message.text);
		for (let i = 0; i < message.suggestions.length; i++) Suggestion.internalBinaryWrite(message.suggestions[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		if (message.level !== 0) writer.tag(3, WireType.Varint).int32(message.level);
		if (message.status !== "") writer.tag(4, WireType.LengthDelimited).string(message.status);
		for (let i = 0; i < message.spans.length; i++) TextSpan.internalBinaryWrite(message.spans[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.MisspelledEntry
*/
const MisspelledEntry = new MisspelledEntry$Type();
var TextSpan$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.TextSpan", [{
			no: 1,
			name: "start",
			kind: "scalar",
			T: 3,
			L: 0
		}, {
			no: 2,
			name: "end",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.start = 0n;
		message.end = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.start = reader.int64().toBigInt();
					break;
				case 2:
					message.end = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.start !== 0n) writer.tag(1, WireType.Varint).int64(message.start);
		if (message.end !== 0n) writer.tag(2, WireType.Varint).int64(message.end);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.TextSpan
*/
const TextSpan = new TextSpan$Type();
var SuggestionsRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.SuggestionsRequest", [
			{
				no: 1,
				name: "text",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "language",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "custom_only",
				kind: "scalar",
				T: 8
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.text = "";
		message.language = "";
		message.customOnly = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.text = reader.string();
					break;
				case 2:
					message.language = reader.string();
					break;
				case 3:
					message.customOnly = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.text !== "") writer.tag(1, WireType.LengthDelimited).string(message.text);
		if (message.language !== "") writer.tag(2, WireType.LengthDelimited).string(message.language);
		if (message.customOnly !== false) writer.tag(3, WireType.Varint).bool(message.customOnly);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.SuggestionsRequest
*/
const SuggestionsRequest = new SuggestionsRequest$Type();
var SuggestionsResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.SuggestionsResponse", [{
			no: 1,
			name: "suggestions",
			kind: "message",
			repeat: 2,
			T: () => Suggestion
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.suggestions = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.suggestions.push(Suggestion.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.suggestions.length; i++) Suggestion.internalBinaryWrite(message.suggestions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.SuggestionsResponse
*/
const SuggestionsResponse = new SuggestionsResponse$Type();
var Suggestion$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.Suggestion", [{
			no: 1,
			name: "text",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "description",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.text = "";
		message.description = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.text = reader.string();
					break;
				case 2:
					message.description = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.text !== "") writer.tag(1, WireType.LengthDelimited).string(message.text);
		if (message.description !== "") writer.tag(2, WireType.LengthDelimited).string(message.description);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.Suggestion
*/
const Suggestion = new Suggestion$Type();
var ListEntriesRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.ListEntriesRequest", [
			{
				no: 1,
				name: "language",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "page",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 3,
				name: "query",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "status",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "page_size",
				kind: "scalar",
				T: 3,
				L: 0
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.language = "";
		message.page = 0n;
		message.query = "";
		message.status = "";
		message.pageSize = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.language = reader.string();
					break;
				case 2:
					message.page = reader.int64().toBigInt();
					break;
				case 3:
					message.query = reader.string();
					break;
				case 4:
					message.status = reader.string();
					break;
				case 5:
					message.pageSize = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.language !== "") writer.tag(1, WireType.LengthDelimited).string(message.language);
		if (message.page !== 0n) writer.tag(2, WireType.Varint).int64(message.page);
		if (message.query !== "") writer.tag(3, WireType.LengthDelimited).string(message.query);
		if (message.status !== "") writer.tag(4, WireType.LengthDelimited).string(message.status);
		if (message.pageSize !== 0n) writer.tag(5, WireType.Varint).int64(message.pageSize);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.ListEntriesRequest
*/
const ListEntriesRequest = new ListEntriesRequest$Type();
var ListEntriesResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.ListEntriesResponse", [{
			no: 1,
			name: "entries",
			kind: "message",
			repeat: 2,
			T: () => CustomEntry
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.entries = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.entries.push(CustomEntry.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.entries.length; i++) CustomEntry.internalBinaryWrite(message.entries[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.ListEntriesResponse
*/
const ListEntriesResponse = new ListEntriesResponse$Type();
var CustomEntry$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.CustomEntry", [
			{
				no: 1,
				name: "language",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "text",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "status",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "description",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "common_mistakes",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 6,
				name: "level",
				kind: "enum",
				T: () => ["elephant.spell.CorrectionLevel", CorrectionLevel]
			},
			{
				no: 7,
				name: "forms",
				kind: "map",
				K: 9,
				V: {
					kind: "scalar",
					T: 9
				}
			},
			{
				no: 8,
				name: "updated",
				kind: "scalar",
				T: 9
			},
			{
				no: 9,
				name: "updated_by",
				kind: "scalar",
				T: 9
			},
			{
				no: 10,
				name: "case_sensitive",
				kind: "scalar",
				T: 8
			},
			{
				no: 11,
				name: "before",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 12,
				name: "after",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 13,
				name: "not_before",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 14,
				name: "not_after",
				kind: "scalar",
				repeat: 2,
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.language = "";
		message.text = "";
		message.status = "";
		message.description = "";
		message.commonMistakes = [];
		message.level = 0;
		message.forms = {};
		message.updated = "";
		message.updatedBy = "";
		message.caseSensitive = false;
		message.before = [];
		message.after = [];
		message.notBefore = [];
		message.notAfter = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.language = reader.string();
					break;
				case 2:
					message.text = reader.string();
					break;
				case 3:
					message.status = reader.string();
					break;
				case 4:
					message.description = reader.string();
					break;
				case 5:
					message.commonMistakes.push(reader.string());
					break;
				case 6:
					message.level = reader.int32();
					break;
				case 7:
					this.binaryReadMap7(message.forms, reader, options);
					break;
				case 8:
					message.updated = reader.string();
					break;
				case 9:
					message.updatedBy = reader.string();
					break;
				case 10:
					message.caseSensitive = reader.bool();
					break;
				case 11:
					message.before.push(reader.string());
					break;
				case 12:
					message.after.push(reader.string());
					break;
				case 13:
					message.notBefore.push(reader.string());
					break;
				case 14:
					message.notAfter.push(reader.string());
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap7(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = reader.string();
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.spell.CustomEntry.forms");
			}
		}
		map[key ?? ""] = val ?? "";
	}
	internalBinaryWrite(message, writer, options) {
		if (message.language !== "") writer.tag(1, WireType.LengthDelimited).string(message.language);
		if (message.text !== "") writer.tag(2, WireType.LengthDelimited).string(message.text);
		if (message.status !== "") writer.tag(3, WireType.LengthDelimited).string(message.status);
		if (message.description !== "") writer.tag(4, WireType.LengthDelimited).string(message.description);
		for (let i = 0; i < message.commonMistakes.length; i++) writer.tag(5, WireType.LengthDelimited).string(message.commonMistakes[i]);
		if (message.level !== 0) writer.tag(6, WireType.Varint).int32(message.level);
		for (let k of globalThis.Object.keys(message.forms)) writer.tag(7, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.forms[k]).join();
		if (message.updated !== "") writer.tag(8, WireType.LengthDelimited).string(message.updated);
		if (message.updatedBy !== "") writer.tag(9, WireType.LengthDelimited).string(message.updatedBy);
		if (message.caseSensitive !== false) writer.tag(10, WireType.Varint).bool(message.caseSensitive);
		for (let i = 0; i < message.before.length; i++) writer.tag(11, WireType.LengthDelimited).string(message.before[i]);
		for (let i = 0; i < message.after.length; i++) writer.tag(12, WireType.LengthDelimited).string(message.after[i]);
		for (let i = 0; i < message.notBefore.length; i++) writer.tag(13, WireType.LengthDelimited).string(message.notBefore[i]);
		for (let i = 0; i < message.notAfter.length; i++) writer.tag(14, WireType.LengthDelimited).string(message.notAfter[i]);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.CustomEntry
*/
const CustomEntry = new CustomEntry$Type();
var ListDictionariesRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.ListDictionariesRequest", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.ListDictionariesRequest
*/
const ListDictionariesRequest = new ListDictionariesRequest$Type();
var ListDictionariesResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.ListDictionariesResponse", [{
			no: 1,
			name: "dictionaries",
			kind: "message",
			repeat: 2,
			T: () => CustomDictionary
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.dictionaries = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.dictionaries.push(CustomDictionary.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.dictionaries.length; i++) CustomDictionary.internalBinaryWrite(message.dictionaries[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.ListDictionariesResponse
*/
const ListDictionariesResponse = new ListDictionariesResponse$Type();
var CustomDictionary$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.CustomDictionary", [
			{
				no: 1,
				name: "language",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "entry_count",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 3,
				name: "pending_count",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 4,
				name: "rule_count",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 5,
				name: "rule_pending_count",
				kind: "scalar",
				T: 3,
				L: 0
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.language = "";
		message.entryCount = 0n;
		message.pendingCount = 0n;
		message.ruleCount = 0n;
		message.rulePendingCount = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.language = reader.string();
					break;
				case 2:
					message.entryCount = reader.int64().toBigInt();
					break;
				case 3:
					message.pendingCount = reader.int64().toBigInt();
					break;
				case 4:
					message.ruleCount = reader.int64().toBigInt();
					break;
				case 5:
					message.rulePendingCount = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.language !== "") writer.tag(1, WireType.LengthDelimited).string(message.language);
		if (message.entryCount !== 0n) writer.tag(2, WireType.Varint).int64(message.entryCount);
		if (message.pendingCount !== 0n) writer.tag(3, WireType.Varint).int64(message.pendingCount);
		if (message.ruleCount !== 0n) writer.tag(4, WireType.Varint).int64(message.ruleCount);
		if (message.rulePendingCount !== 0n) writer.tag(5, WireType.Varint).int64(message.rulePendingCount);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.CustomDictionary
*/
const CustomDictionary = new CustomDictionary$Type();
var GetEntryRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.GetEntryRequest", [{
			no: 1,
			name: "language",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "text",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.language = "";
		message.text = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.language = reader.string();
					break;
				case 2:
					message.text = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.language !== "") writer.tag(1, WireType.LengthDelimited).string(message.language);
		if (message.text !== "") writer.tag(2, WireType.LengthDelimited).string(message.text);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.GetEntryRequest
*/
const GetEntryRequest = new GetEntryRequest$Type();
var GetEntryResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.GetEntryResponse", [{
			no: 1,
			name: "entry",
			kind: "message",
			T: () => CustomEntry
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.entry = CustomEntry.internalBinaryRead(reader, reader.uint32(), options, message.entry);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.entry) CustomEntry.internalBinaryWrite(message.entry, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.GetEntryResponse
*/
const GetEntryResponse = new GetEntryResponse$Type();
var SetEntryRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.SetEntryRequest", [{
			no: 1,
			name: "entry",
			kind: "message",
			T: () => CustomEntry
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.entry = CustomEntry.internalBinaryRead(reader, reader.uint32(), options, message.entry);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.entry) CustomEntry.internalBinaryWrite(message.entry, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.SetEntryRequest
*/
const SetEntryRequest = new SetEntryRequest$Type();
var SetEntryResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.SetEntryResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.SetEntryResponse
*/
const SetEntryResponse = new SetEntryResponse$Type();
var SetEntryStatusRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.SetEntryStatusRequest", [
			{
				no: 1,
				name: "language",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "text",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "status",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.language = "";
		message.text = "";
		message.status = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.language = reader.string();
					break;
				case 2:
					message.text = reader.string();
					break;
				case 3:
					message.status = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.language !== "") writer.tag(1, WireType.LengthDelimited).string(message.language);
		if (message.text !== "") writer.tag(2, WireType.LengthDelimited).string(message.text);
		if (message.status !== "") writer.tag(3, WireType.LengthDelimited).string(message.status);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.SetEntryStatusRequest
*/
const SetEntryStatusRequest = new SetEntryStatusRequest$Type();
var SetEntryStatusResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.SetEntryStatusResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.SetEntryStatusResponse
*/
const SetEntryStatusResponse = new SetEntryStatusResponse$Type();
var DeleteEntryRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.DeleteEntryRequest", [{
			no: 1,
			name: "language",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "text",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.language = "";
		message.text = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.language = reader.string();
					break;
				case 2:
					message.text = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.language !== "") writer.tag(1, WireType.LengthDelimited).string(message.language);
		if (message.text !== "") writer.tag(2, WireType.LengthDelimited).string(message.text);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.DeleteEntryRequest
*/
const DeleteEntryRequest = new DeleteEntryRequest$Type();
var DeleteEntryResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.DeleteEntryResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.DeleteEntryResponse
*/
const DeleteEntryResponse = new DeleteEntryResponse$Type();
var RenameEntryRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.RenameEntryRequest", [
			{
				no: 1,
				name: "language",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "text",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "new_text",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.language = "";
		message.text = "";
		message.newText = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.language = reader.string();
					break;
				case 2:
					message.text = reader.string();
					break;
				case 3:
					message.newText = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.language !== "") writer.tag(1, WireType.LengthDelimited).string(message.language);
		if (message.text !== "") writer.tag(2, WireType.LengthDelimited).string(message.text);
		if (message.newText !== "") writer.tag(3, WireType.LengthDelimited).string(message.newText);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.RenameEntryRequest
*/
const RenameEntryRequest = new RenameEntryRequest$Type();
var RenameEntryResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.RenameEntryResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.RenameEntryResponse
*/
const RenameEntryResponse = new RenameEntryResponse$Type();
var Rule$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.Rule", [
			{
				no: 14,
				name: "id",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 1,
				name: "language",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "status",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "description",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "level",
				kind: "enum",
				T: () => ["elephant.spell.CorrectionLevel", CorrectionLevel]
			},
			{
				no: 6,
				name: "pattern",
				kind: "scalar",
				T: 9
			},
			{
				no: 7,
				name: "replacement",
				kind: "scalar",
				T: 9
			},
			{
				no: 8,
				name: "before",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 9,
				name: "after",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 10,
				name: "not_before",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 11,
				name: "not_after",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 12,
				name: "updated",
				kind: "scalar",
				T: 9
			},
			{
				no: 13,
				name: "updated_by",
				kind: "scalar",
				T: 9
			},
			{
				no: 15,
				name: "case_sensitive",
				kind: "scalar",
				T: 8
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = 0n;
		message.language = "";
		message.name = "";
		message.status = "";
		message.description = "";
		message.level = 0;
		message.pattern = "";
		message.replacement = "";
		message.before = [];
		message.after = [];
		message.notBefore = [];
		message.notAfter = [];
		message.updated = "";
		message.updatedBy = "";
		message.caseSensitive = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 14:
					message.id = reader.int64().toBigInt();
					break;
				case 1:
					message.language = reader.string();
					break;
				case 2:
					message.name = reader.string();
					break;
				case 3:
					message.status = reader.string();
					break;
				case 4:
					message.description = reader.string();
					break;
				case 5:
					message.level = reader.int32();
					break;
				case 6:
					message.pattern = reader.string();
					break;
				case 7:
					message.replacement = reader.string();
					break;
				case 8:
					message.before.push(reader.string());
					break;
				case 9:
					message.after.push(reader.string());
					break;
				case 10:
					message.notBefore.push(reader.string());
					break;
				case 11:
					message.notAfter.push(reader.string());
					break;
				case 12:
					message.updated = reader.string();
					break;
				case 13:
					message.updatedBy = reader.string();
					break;
				case 15:
					message.caseSensitive = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.language !== "") writer.tag(1, WireType.LengthDelimited).string(message.language);
		if (message.name !== "") writer.tag(2, WireType.LengthDelimited).string(message.name);
		if (message.status !== "") writer.tag(3, WireType.LengthDelimited).string(message.status);
		if (message.description !== "") writer.tag(4, WireType.LengthDelimited).string(message.description);
		if (message.level !== 0) writer.tag(5, WireType.Varint).int32(message.level);
		if (message.pattern !== "") writer.tag(6, WireType.LengthDelimited).string(message.pattern);
		if (message.replacement !== "") writer.tag(7, WireType.LengthDelimited).string(message.replacement);
		for (let i = 0; i < message.before.length; i++) writer.tag(8, WireType.LengthDelimited).string(message.before[i]);
		for (let i = 0; i < message.after.length; i++) writer.tag(9, WireType.LengthDelimited).string(message.after[i]);
		for (let i = 0; i < message.notBefore.length; i++) writer.tag(10, WireType.LengthDelimited).string(message.notBefore[i]);
		for (let i = 0; i < message.notAfter.length; i++) writer.tag(11, WireType.LengthDelimited).string(message.notAfter[i]);
		if (message.updated !== "") writer.tag(12, WireType.LengthDelimited).string(message.updated);
		if (message.updatedBy !== "") writer.tag(13, WireType.LengthDelimited).string(message.updatedBy);
		if (message.id !== 0n) writer.tag(14, WireType.Varint).int64(message.id);
		if (message.caseSensitive !== false) writer.tag(15, WireType.Varint).bool(message.caseSensitive);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.Rule
*/
const Rule = new Rule$Type();
var ListRulesRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.ListRulesRequest", [
			{
				no: 1,
				name: "language",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "page",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 3,
				name: "query",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "status",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "page_size",
				kind: "scalar",
				T: 3,
				L: 0
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.language = "";
		message.page = 0n;
		message.query = "";
		message.status = "";
		message.pageSize = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.language = reader.string();
					break;
				case 2:
					message.page = reader.int64().toBigInt();
					break;
				case 3:
					message.query = reader.string();
					break;
				case 4:
					message.status = reader.string();
					break;
				case 5:
					message.pageSize = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.language !== "") writer.tag(1, WireType.LengthDelimited).string(message.language);
		if (message.page !== 0n) writer.tag(2, WireType.Varint).int64(message.page);
		if (message.query !== "") writer.tag(3, WireType.LengthDelimited).string(message.query);
		if (message.status !== "") writer.tag(4, WireType.LengthDelimited).string(message.status);
		if (message.pageSize !== 0n) writer.tag(5, WireType.Varint).int64(message.pageSize);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.ListRulesRequest
*/
const ListRulesRequest = new ListRulesRequest$Type();
var ListRulesResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.ListRulesResponse", [{
			no: 1,
			name: "rules",
			kind: "message",
			repeat: 2,
			T: () => Rule
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.rules = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.rules.push(Rule.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.rules.length; i++) Rule.internalBinaryWrite(message.rules[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.ListRulesResponse
*/
const ListRulesResponse = new ListRulesResponse$Type();
var GetRuleRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.GetRuleRequest", [{
			no: 1,
			name: "id",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.id = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.id !== 0n) writer.tag(1, WireType.Varint).int64(message.id);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.GetRuleRequest
*/
const GetRuleRequest = new GetRuleRequest$Type();
var GetRuleResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.GetRuleResponse", [{
			no: 1,
			name: "rule",
			kind: "message",
			T: () => Rule
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.rule = Rule.internalBinaryRead(reader, reader.uint32(), options, message.rule);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.rule) Rule.internalBinaryWrite(message.rule, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.GetRuleResponse
*/
const GetRuleResponse = new GetRuleResponse$Type();
var SetRuleRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.SetRuleRequest", [{
			no: 1,
			name: "rule",
			kind: "message",
			T: () => Rule
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.rule = Rule.internalBinaryRead(reader, reader.uint32(), options, message.rule);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.rule) Rule.internalBinaryWrite(message.rule, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.SetRuleRequest
*/
const SetRuleRequest = new SetRuleRequest$Type();
var SetRuleResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.SetRuleResponse", [{
			no: 1,
			name: "id",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.id = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.id !== 0n) writer.tag(1, WireType.Varint).int64(message.id);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.SetRuleResponse
*/
const SetRuleResponse = new SetRuleResponse$Type();
var SetRuleStatusRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.SetRuleStatusRequest", [{
			no: 1,
			name: "id",
			kind: "scalar",
			T: 3,
			L: 0
		}, {
			no: 2,
			name: "status",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = 0n;
		message.status = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.id = reader.int64().toBigInt();
					break;
				case 2:
					message.status = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.id !== 0n) writer.tag(1, WireType.Varint).int64(message.id);
		if (message.status !== "") writer.tag(2, WireType.LengthDelimited).string(message.status);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.SetRuleStatusRequest
*/
const SetRuleStatusRequest = new SetRuleStatusRequest$Type();
var SetRuleStatusResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.SetRuleStatusResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.SetRuleStatusResponse
*/
const SetRuleStatusResponse = new SetRuleStatusResponse$Type();
var DeleteRuleRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.DeleteRuleRequest", [{
			no: 1,
			name: "id",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.id = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.id !== 0n) writer.tag(1, WireType.Varint).int64(message.id);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.DeleteRuleRequest
*/
const DeleteRuleRequest = new DeleteRuleRequest$Type();
var DeleteRuleResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.spell.DeleteRuleResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.spell.DeleteRuleResponse
*/
const DeleteRuleResponse = new DeleteRuleResponse$Type();
/**
* @generated ServiceType for protobuf service elephant.spell.Check
*/
const Check = new ServiceType("elephant.spell.Check", [{
	name: "Text",
	options: {},
	I: TextRequest,
	O: TextResponse
}, {
	name: "Suggestions",
	options: {},
	I: SuggestionsRequest,
	O: SuggestionsResponse
}]);
/**
* @generated ServiceType for protobuf service elephant.spell.Dictionaries
*/
const Dictionaries = new ServiceType("elephant.spell.Dictionaries", [
	{
		name: "SupportedLanguages",
		options: {},
		I: SupportedLanguagesRequest,
		O: SupportedLanguagesResponse
	},
	{
		name: "ListDictionaries",
		options: {},
		I: ListDictionariesRequest,
		O: ListDictionariesResponse
	},
	{
		name: "ListEntries",
		options: {},
		I: ListEntriesRequest,
		O: ListEntriesResponse
	},
	{
		name: "GetEntry",
		options: {},
		I: GetEntryRequest,
		O: GetEntryResponse
	},
	{
		name: "SetEntry",
		options: {},
		I: SetEntryRequest,
		O: SetEntryResponse
	},
	{
		name: "SetEntryStatus",
		options: {},
		I: SetEntryStatusRequest,
		O: SetEntryStatusResponse
	},
	{
		name: "DeleteEntry",
		options: {},
		I: DeleteEntryRequest,
		O: DeleteEntryResponse
	},
	{
		name: "RenameEntry",
		options: {},
		I: RenameEntryRequest,
		O: RenameEntryResponse
	}
]);
/**
* @generated ServiceType for protobuf service elephant.spell.Rules
*/
const Rules = new ServiceType("elephant.spell.Rules", [
	{
		name: "ListRules",
		options: {},
		I: ListRulesRequest,
		O: ListRulesResponse
	},
	{
		name: "GetRule",
		options: {},
		I: GetRuleRequest,
		O: GetRuleResponse
	},
	{
		name: "SetRule",
		options: {},
		I: SetRuleRequest,
		O: SetRuleResponse
	},
	{
		name: "SetRuleStatus",
		options: {},
		I: SetRuleStatusRequest,
		O: SetRuleStatusResponse
	},
	{
		name: "DeleteRule",
		options: {},
		I: DeleteRuleRequest,
		O: DeleteRuleResponse
	}
]);
// src/spell/service.client.ts
/**
* Check content for spelling errors.
*
* @generated from protobuf service elephant.spell.Check
*/
var CheckClient = class {
	constructor(_transport) {
		this._transport = _transport;
		this.typeName = Check.typeName;
		this.methods = Check.methods;
		this.options = Check.options;
	}
	/**
	* Text spellchecks a text and returns the misspelled words or phrases.
	*
	* @generated from protobuf rpc: Text
	*/
	text(input, options) {
		const method = this.methods[0], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Suggestions returns suggestions for a word or phrase.
	*
	* @generated from protobuf rpc: Suggestions
	*/
	suggestions(input, options) {
		const method = this.methods[1], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
};
/**
* Dictionaries is used to manage custom dictionary entries. Custom dictionaries
* can be used to add both words and phrases.
*
* @generated from protobuf service elephant.spell.Dictionaries
*/
var DictionariesClient = class {
	constructor(_transport) {
		this._transport = _transport;
		this.typeName = Dictionaries.typeName;
		this.methods = Dictionaries.methods;
		this.options = Dictionaries.options;
	}
	/**
	* SupportedLanguages returns a list of supported languages.
	*
	* @generated from protobuf rpc: SupportedLanguages
	*/
	supportedLanguages(input, options) {
		const method = this.methods[0], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* ListDictionaries lists the currently available custom dictionaries.
	*
	* @generated from protobuf rpc: ListDictionaries
	*/
	listDictionaries(input, options) {
		const method = this.methods[1], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* ListEntries lists entries in the custom dictionaries.
	*
	* @generated from protobuf rpc: ListEntries
	*/
	listEntries(input, options) {
		const method = this.methods[2], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetEntry returns the details of a custom word or phrase.
	*
	* @generated from protobuf rpc: GetEntry
	*/
	getEntry(input, options) {
		const method = this.methods[3], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* SetEntry is used to add or update custom dictionary entries.
	*
	* @generated from protobuf rpc: SetEntry
	*/
	setEntry(input, options) {
		const method = this.methods[4], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* SetEntryStatus updates only the moderation status of an entry. It is a
	* lightweight alternative to SetEntry for accept/reject workflows that don't
	* need to round-trip the whole entry.
	*
	* @generated from protobuf rpc: SetEntryStatus
	*/
	setEntryStatus(input, options) {
		const method = this.methods[5], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* DeleteEntry is used to remove an entry.
	*
	* @generated from protobuf rpc: DeleteEntry
	*/
	deleteEntry(input, options) {
		const method = this.methods[6], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* RenameEntry changes the text of a custom dictionary entry, keeping the rest
	* of its data. The text is the entry's identity, so renaming is a dedicated
	* operation rather than a SetEntry.
	*
	* @generated from protobuf rpc: RenameEntry
	*/
	renameEntry(input, options) {
		const method = this.methods[7], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
};
/**
* Rules manages pattern rules, which match a text pattern with placeholders
* rather than fixed strings. They are a separate kind of entity from dictionary
* words.
*
* @generated from protobuf service elephant.spell.Rules
*/
var RulesClient = class {
	constructor(_transport) {
		this._transport = _transport;
		this.typeName = Rules.typeName;
		this.methods = Rules.methods;
		this.options = Rules.options;
	}
	/**
	* ListRules lists pattern rules.
	*
	* @generated from protobuf rpc: ListRules
	*/
	listRules(input, options) {
		const method = this.methods[0], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetRule returns the details of a single rule.
	*
	* @generated from protobuf rpc: GetRule
	*/
	getRule(input, options) {
		const method = this.methods[1], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* SetRule adds or updates a rule.
	*
	* @generated from protobuf rpc: SetRule
	*/
	setRule(input, options) {
		const method = this.methods[2], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* SetRuleStatus updates only the moderation status of a rule.
	*
	* @generated from protobuf rpc: SetRuleStatus
	*/
	setRuleStatus(input, options) {
		const method = this.methods[3], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* DeleteRule removes a rule.
	*
	* @generated from protobuf rpc: DeleteRule
	*/
	deleteRule(input, options) {
		const method = this.methods[4], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
};
export { Check, CheckClient, CorrectionLevel, CustomDictionary, CustomEntry, DeleteEntryRequest, DeleteEntryResponse, DeleteRuleRequest, DeleteRuleResponse, Dictionaries, DictionariesClient, GetEntryRequest, GetEntryResponse, GetRuleRequest, GetRuleResponse, Language, ListDictionariesRequest, ListDictionariesResponse, ListEntriesRequest, ListEntriesResponse, ListRulesRequest, ListRulesResponse, Misspelled, MisspelledEntry, RenameEntryRequest, RenameEntryResponse, Rule, Rules, RulesClient, SetEntryRequest, SetEntryResponse, SetEntryStatusRequest, SetEntryStatusResponse, SetRuleRequest, SetRuleResponse, SetRuleStatusRequest, SetRuleStatusResponse, Suggestion, SuggestionsRequest, SuggestionsResponse, SupportedLanguagesRequest, SupportedLanguagesResponse, TextRequest, TextResponse, TextSpan };
